import { WorkflowStage } from '@/types/palette';
import styles from './styles.module.scss';

type StageItem = {
	id: WorkflowStage;
	label: string;
	stageName: string;
	description: string;
};

const STAGES: StageItem[] = [
	{
		id: 'predesign_programming',
		label: 'Gate 1',
		stageName: 'Massing Studies',
		description:
			'Project brief is developed, requirements are clarified, budgets and success criteria are set, and the team prepares to start design directional / indicative use.',
	},
	{
		id: 'schematic',
		label: 'Gate 2',
		stageName: 'Informed Design Studies',
		description:
			'Big ideas are explored — massing, layout, orientation, and early performance intent. Multiple options are tested and compared.',
	},
	{
		id: 'design_development',
		label: 'Gate 3',
		stageName: 'Targeted Design Studies',
		description:
			'The preferred concept is refined and coordinated. Key systems, spatial logic, and performance strategies are resolved and narrowed.',
	},
];

interface StageBarProps {
	currentStage: WorkflowStage;
	onChange: (stage: WorkflowStage) => void;
}

export const StageBar = ({ currentStage, onChange }: StageBarProps) => {
	const activeStage = STAGES.find((stage) => stage.id === currentStage) ?? STAGES[0];
	const activeIndex = STAGES.findIndex((stage) => stage.id === activeStage.id);

	return (
		<div className={styles.stageBar}>
			<div className={styles.stageToolbar}>
				<div className={styles.stageLead}>
					<div className={styles.stageLabel}>Project Stage</div>
					<div className={styles.stageName}>{activeStage.stageName}</div>
				</div>
				<div className={styles.stageTrack}>
					{STAGES.map((stage, index) => {
						const isCompleted = index < activeIndex;
						const isActive = index === activeIndex;
						return (
							<div key={stage.id} className={styles.stageTrackItem}>
								<button
									type="button"
									className={`${styles.stageNode} ${
										isCompleted
											? styles.stageNodeCompleted
											: isActive
												? styles.stageNodeActive
												: styles.stageNodeUpcoming
									}`}
									onClick={() => onChange(stage.id)}
									aria-current={isActive ? 'step' : undefined}
								>
									<span className={styles.stageCircle}>
										{isCompleted ? '✓' : index + 1}
									</span>
									<span className={styles.stageNodeLabel}>{stage.label}</span>
								</button>
								{index < STAGES.length - 1 ? (
									<div
										className={`${styles.stageConnector} ${
											isCompleted ? styles.stageConnectorCompleted : ''
										}`}
									/>
								) : null}
							</div>
						);
					})}
				</div>
			</div>

			<div className={styles.stageDescription} title={activeStage.description}>
				{activeStage.description}
			</div>
		</div>
	);
};
